import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MDBDataTable } from "mdbreact";
import _ from "lodash";
import "./styles.css";
import * as FileSaver from 'file-saver';
import LoadingOverlay from "react-loading-overlay";

import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'
//import styled, { css } from "styled-components";

//import ReactGA from "react-ga4";




var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
var Dispatch_From_Date_val;
var dispatch_to_Date_val;
const Heading = [['Client', 'Bill No.', 'SubGroup Id','Picking Method', "Bill Date", 'Dispatch Date/Time','LB Product Code', 'Prod Code', 'Prod Desc', 'MRP', 'UPC', 'Order Qty', 'Landed', 'Diff(Order-landed)Qty', 'Group Assigned', 'Diff(Landed-Group Assign)Qty', 'Sub GROUP ASSIGNED', 'Diff(Group Assign-SubGroup Assign)Qty', 'Inventory Alloc', 'Diff(SubGroup Assigned-Inv.Allc)Qty', 'Picking Confirmed', 'Diff(Inv.Allc-Picking Conf)Qty', 'Packing Confirmed', 'Diff(Picking Conf-Packing Conf)Qty', 'Dispatch Confirmed', 'Diff(Packing Conf-Disptch)Qty', 'Handover Completed', 'Diff(Disptch-Handover)Qty', 'Total Short']];




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);

    this.state = {

      filtered_orderData: "",
      loader1: false,
      isDisabledApply: false,
      fromdate: "",
      todate: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      bill_no: "",
      group_id: "",
      dispatchtodate : "",
      dispatchfromdate : "",
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""
    };
  }

  onBillChange = (evt) => {
    this.setState({
      bill_no: evt.target.value.trim(),
    });
  };

  onGroupChange = (evt) => {
    this.setState({
      group_id: evt.target.value.trim(),
    });
  };


  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };
  DispatchFromDateChange = date  => {
    this.setState({
      dispatchfromdate :  date,
      showFromErr: false

    })  
    if(date){
       Dispatch_From_Date_val = this.convertDate(date);
     }else{
      this.setState({
        dispatchfromdate: ""
      })
      Dispatch_From_Date_val = ""
     }
   
    
}

DispatchToDateChange = date => {
    
    this.setState({
      dispatchtodate :  date,
      showToErr: false
    }) 
    if(date){
      dispatch_to_Date_val = this.convertDate(date);
    }else{
      this.setState({
        dispatchtodate: "",
       
      })
       dispatch_to_Date_val= ""
    }
     
}

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var today = new Date();
    // From_Date_val = this.convertDate(today);
    // to_Date_val = this.convertDate(today);

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        //fromdate: today,
        //todate: today,

      },
      () => {

      }
    );

  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  assembleDispatchData = (dispatchData) => {

    let DispatchData = dispatchData.map((post, index) => {

      return {
        client: post.client,
        outlet_order_no: post.outlet_order_no,
        subgrp_id: post.subgroup_id,
        picking_method : post.picking_method,
        bill_date: post.bill_date,
        dispatch_date :post.dispatch_datetime,
        lb_product_code : post.lb_product_code,
        sku7_code: post.sku7_code,
        prod_desc: post.prod_desc,
        mrp: post.mrp,
        upc: post.upc,
        order_qty: post.order_qty,
        landed: post.landed,
        order_landed_diff: post.order_landed_diff,
        group_assigned: post.group_assigned,
        landed_assign_diff: post.landed_assign_diff,
        sub_grp_assigned: post.sub_grp_assigned,
        grp_subgrp_assign: post.grp_subgrp_assign,
        inventory_allocated: post.inventory_allocated,
        subgrp_alloc_diff: post.subgrp_alloc_diff,
        picking_confirmed: post.picking_confirmed,
        alloc_conf_diff: post.alloc_conf_diff,
        packing_confirmed: post.packing_confirmed,
        pick_pack_conf_diff: post.pick_pack_conf_diff,
        dispatch_confirmed: post.dispatch_confirmed,
        conf_dispatch_diff: post.conf_dispatch_diff,
        handover_completed: post.handover_completed,
        dispatch_handover_diff: post.dispatch_handover_diff,
        total_short: post.total_short,

      };
    });

    this.setState({
      orderData: DispatchData,
      filtered_orderData: DispatchData,
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };

  fetchDispatch = (order_no) => {

  /*  ReactGA.event({
      category: "Report",
      action: "view",
      label: "SO TO Dispatch report", // optional
    });*/


    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    // var batch = localStorage.getItem('batch_id');
    const payload = {
      "request_type": "view",
      "group_id": this.state.group_id,
      "to_date": to_Date_val,
      "from_date": From_Date_val,
      "dispatch_from_date":Dispatch_From_Date_val,
      "dispatch_to_date" : dispatch_to_Date_val,
      "bill_number": this.state.bill_no,

    };
    addAnalytics('Report', 'View SO To Dispatch Report', payload);

    API.post('/product/uploaded-dispatch-report/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

        if (data.success == false) {
          this.setState({
            failed_message: data.message
          })
          this.toggle();
        }


        if (data.length == 0) {

          this.setState({
            dispatch_status: true,
            showFetchDispatchData: true,
            loading_overlay: false,
            loading: false,

          });
          return false;
        }



        this.setState({
          tableRowsMap: this.assembleDispatchData(data.data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function (error) { });
  };
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;

    const dispatchData = {
      columns: [
        {
          label: "Client",

          field: "client",
          width: 140,
        },

        {
          label: "Bill No.",

          field: "outlet_order_no",
          width: 140,
        },
        {
          label: "SubGroup ID",

          field: "subgrp_id",
          width: 120,
        },
        {
          label: "Picking method",

          field: "picking_method",
          width: 150,
        },
        {
          label: "Bill Date",

          field: "bill_date",
          width: 160,
        },
        {
          label: "Dispatch Date",

          field: "dispatch_date",
          width: 160,
        },
        {
          label: "LB Product Code",

          field: "lb_product_code",
          width: 160,
        },
        {
          label: "Prod Code",

          field: "sku7_code",
          width: 160,
        },
        {
          label: "Prod Desc",

          field: "prod_desc",
          width: 160,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 90,
        },
        {
          label: "UPC",

          field: "upc",
          width: 110,
        },


        {
          label: "Order Qty",

          field: "order_qty",
          width: 100,
        },
        {
          label: "Landed",

          field: "landed",
          width: 110,
        },
        {
          label: "Diff(Order-landed)Qty",

          field: "order_landed_diff",
          width: 150,
        },
        {
          label: "Group Assigned",

          field: "group_assigned",
          width: 110,
        },

        {
          label: "Diff(Landed-Group Assign)Qty",
          field: "landed_assign_diff",
          width: 140,
        },

        {
          label: "Sub GROUP ASSIGNED",

          field: "sub_grp_assigned",
          width: 150,
        },

        {
          label: "Diff(Group Assign-SubGroup Assign)Qty",

          field: "grp_subgrp_assign",
          width: 140,
        },
        {
          label: "Inventory Alloc",

          field: "inventory_allocated",
          width: 120,
        },
        {
          label: "Diff(SubGroup Assigned-Inv.Allc)Qty",

          field: "subgrp_alloc_diff",
          width: 150,
        },

        {
          label: "Picking Confirmed",

          field: "picking_confirmed",
          width: 110,
        },


        {
          label: "Diff(Inv.Allc-Picking Conf)Qty",

          field: "alloc_conf_diff",
          width: 140,
        },



        {
          label: "Packing Confirmed",

          field: "packing_confirmed",
          width: 120,
        },

        {
          label: "Diff(Picking Conf-Packing Conf)Qty",

          field: "pick_pack_conf_diff",
          width: 150,
        },

        {
          label: "Dispatch Confirmed",

          field: "dispatch_confirmed",
          width: 130,
        },

        {
          label: "Diff(Packing Conf-Disptch)Qty",

          field: "conf_dispatch_diff",
          width: 150,
        },

        {
          label: "Handover Completed",

          field: "handover_completed",
          width: 130,
        },

        {
          label: "Diff(Disptch-Handover)Qty",

          field: "dispatch_handover_diff",
          width: 130,
        },

        {
          label: "Total Short",

          field: "total_short",
          width: 110,
        },


      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>

        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <Overlay>
            <form className="form" onSubmit={handleSubmit}>
             <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Bill From Date</span>
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={this.state.from_date}
                    onChange={this.FromDateChange}
                    className="ledger_fromdate"
                    placeholderText="Bill From Date"
                    format='yyyy-MM-dd'
                  />
                   <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                  {this.state.showFromErr &&
                    <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                  }
                  {this.state.dateOrderError && (
                    <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                  )}
                </div>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Bill To Date</span>
                <div style={{ position: 'relative' }}>
                  <DatePicker
                    selected={this.state.to_date}
                    onChange={this.ToDateChange}
                    className="ledger_todate"
                    placeholderText="Bill To Date"
                  />
                  <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                  {this.state.showToErr &&
                    <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                  }
                  {this.state.dateRangeError &&
                    <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                  }
                </div>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Dispatch From Date</span>
                <div style={{ position: 'relative' }}>
                
                  <DatePicker
                    selected={this.state.dispatchfromdate}
                    onChange={this.DispatchFromDateChange}
                    className="ledger_fromdate"
                    placeholderText="Dispatch From Date"
                    format='yyyy-MM-dd'
                  />
                  <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                  {this.state.showFromErr &&
                  <span style={{color: 'red', fontSize: 11}}>Please Select Dispatch From Date</span>
                  }
                </div>
              </div>
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Dispatch To Date</span>
                <div style={{ position: 'relative' }}>
                  <DatePicker 
                  selected={this.state.dispatchtodate}
                  onChange={this.DispatchToDateChange}
                  className="ledger_todate"
                  placeholderText="Dispatch To Date"
                  />
                   <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                  {this.state.showToErr &&
                    <span style={{color: 'red', fontSize: 11}}>Please Select Dispatch To Date</span>
                  }
                </div>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Group</span>
                <div style={{ position: 'relative' }}>
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Enter Group" onChange={this.onGroupChange} />
                </div>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Bill No.</span>
                <div style={{ position: 'relative' }}>
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Enter Bill No" onChange={this.onBillChange} />
                </div>
              </div>


              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      marginRight: '10px',
                    }}
                    id="button_view"
                    onClick={() => this.fetchDispatch(this.state.order_no)}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View 
                  </Button>

                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        padding: "5px 10px",
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, "SO To Dispatch Report", Heading)}
                  >
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '22px' }} // Adjust size as needed
                    />
                    Download
                  </Button>
                </ButtonToolbar>                    
              </div>
            </form>
          </Overlay>
          {!this.state.showFetchDispatchData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}


          {this.state.showFetchDispatchData && (
            <div>
              <div>
                
                {From_Date_val &&
                  <div className="date-container">
                   {From_Date_val}
                  </div>
                }

                {to_Date_val &&
                  <div className="date-container">
                   {to_Date_val}
                  </div>
                }

                {Dispatch_From_Date_val &&
                  <div className="date-container">
                   {Dispatch_From_Date_val}
                  </div>
                }

                {dispatch_to_Date_val &&
                  <div className="date-container">
                   {Dispatch_From_Date_val}
                  </div>
                }

                {this.state.group_id &&
                  <div className="date-container">
                   {this.state.group_id}
                  </div>
                }


                {this.state.bill_no &&
                  <div className="date-container">
                   {this.state.bill_no}
                  </div>
                }

              </div>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: -27 }}
                >
                  <MDBDataTable
                    scrollX
                    scrollY
                    sortable={false}
                    maxHeight="390px"
                    displayEntries={true}
                    onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'So To Dispatch Report', 'datatable_pagination_change' )}
                    striped
                    bordered
                    onSearch={this.filterData}
                    data={dispatchData}
                  />
                </div>
              </div>
            </div>
          )}
        </Card>


      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
